/* Copyright (C) 2020 Carlo Capuano - All Rights Reserved
 * You may use, distribute and modify this code under the
 * terms of the MIT license.
 */
import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/autogenerated/adminService';
import { MonitoringService } from 'src/app/global/monitoring.service';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss'],
})
export class AdministrationComponent implements OnInit {
  constructor(private adminService: AdminService, private monitoringService: MonitoringService) {}

  ngOnInit() {
    this.monitoringService.trackPageView('Administration');
  }

  public raiseError() {
    throw new Error('oh no!');
  }
  public raiseBeError() {
    this.adminService.crash().then(null);
  }
}
